import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { useContext } from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import VerticalContext from '../VerticalContext';

var normalize = function normalize(value) {
  return String(Number(value)) === String(value) ? "".concat(value, "px") : value;
};
/**
 * `Column` component is a part of [Columns](#!/Columns).
 * @since 2.6.0
 */


var Column = function Column(_ref) {
  var _classNames;

  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "columns__column") : _ref$baseClassName,
      className = _ref.className,
      children = _ref.children,
      fill = _ref.fill,
      ratio = _ref.ratio,
      style = _ref.style,
      width = _ref.width,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "children", "fill", "ratio", "style", "width", "minWidth", "maxWidth"]);

  var vertical = useContext(VerticalContext);
  return React.createElement("div", _extends({
    className: classNames(baseClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "--fill"), fill && !vertical), _defineProperty(_classNames, "".concat(baseClassName, "--ratio-").concat(ratio), ratio && !vertical), _defineProperty(_classNames, "".concat(baseClassName, "--has-width"), width && !vertical), _classNames), className),
    style: vertical ? style : _objectSpread({
      width: normalize(width),
      flexBasis: normalize(minWidth),
      maxWidth: normalize(maxWidth)
    }, style)
  }, props), children);
};

export default Column;